import React from 'react';
import PropTypes from 'prop-types';
import { Spacing, Text, ToggleSwitch } from '@reservamos/elements';

/**
 * LabelSwitch component.
 * Render a switch toggle with a label.
 * @param {object} props - id, label, checked, onChange, justifyContent, color, disclaimer.
 * @param {string} props.id - The unique identifier for the switch input.
 * @param {string} props.label - The label text displayed next to the switch.
 * @param {boolean} props.checked - Whether the switch is checked.
 * @param {function} props.onChange - Callback function called when the switch is toggled.
 * @param {string} props.justifyContent - CSS justify-content value for the container spacing.
 * @param {string} props.color - Color value for the switch.
 * @param {string} props.disclaimer - Optional disclaimer text displayed below the label.
 * @returns {JSX.Element} A React component that renders a labeled switch toggle.
 */
const LabelSwitch = ({ id, label, checked, onChange, justifyContent, color, disclaimer }) => (
  <Spacing size="S" alignItems="Center" justifyContent={justifyContent}>
    <label htmlFor={id} className={`${disclaimer ? 'flex flex-col' : ''}`}>
      <Text elementType="span" size="S">
        {label}
      </Text>
      {disclaimer && (
        <Text elementType="span" size="XS">
          {disclaimer}
        </Text>
      )}
    </label>
    <ToggleSwitch
      id={id}
      size="M"
      checked={checked}
      onChange={onChange}
      fillBackground
      color={color}
    />
  </Spacing>
);

LabelSwitch.propTypes = {
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  justifyContent: PropTypes.string,
  disclaimer: PropTypes.string,
  color: PropTypes.string,
};

LabelSwitch.defaultProps = {
  checked: false,
  justifyContent: 'initial',
  color: 'accent',
  disclaimer: '',
};
export default LabelSwitch;
